// extracted by mini-css-extract-plugin
export default {"alertElement":"Alert_alertElement__74PKK","alertContainer":"Alert_alertContainer__2kAdS"};